import { AnyAction, Reducer } from '@reduxjs/toolkit';
import { Action } from 'actions/utils';
import { IReducers } from 'reducers';

/**
 * @deprecated
 * Новые редьюсеры лучше создавать через createSlice
 */
function connectReducers<S>(initialState: S, reducers: IReducers<S>): Reducer<S, AnyAction> {
  return (state = initialState, action: AnyAction) => {
    const reducer = reducers[action.type];

    return reducer ? reducer(state, action as Action<any>) : state;
  };
}

export default connectReducers;
